// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5524bd9","239":"917b8eab","667":"7073938d"}[chunkId] + ".chunk.js";
};